import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27415311"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 20 20",
  fill: "none",
  id: "updateTimerIcon",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9.79944 1.66663C10.9854 1.66633 12.1572 1.92407 13.2335 2.42197C14.3099 2.91986 15.2651 3.64599 16.0327 4.54996L17.1661 3.54163C17.2863 3.43622 17.4342 3.36761 17.5923 3.34397C17.7504 3.32032 17.912 3.34266 18.0577 3.4083C18.2039 3.47402 18.3281 3.58052 18.4153 3.71502C18.5025 3.84953 18.5491 4.00633 18.5494 4.16663V7.49996C18.5494 7.72098 18.4616 7.93294 18.3053 8.08922C18.149 8.2455 17.9371 8.3333 17.7161 8.3333H13.9661C13.7982 8.3328 13.6344 8.28162 13.4961 8.18645C13.3578 8.09129 13.2515 7.95658 13.1911 7.79996C13.1296 7.64125 13.1183 7.46754 13.1585 7.30217C13.1987 7.13681 13.2886 6.98772 13.4161 6.87496L14.7911 5.64996C14.176 4.92376 13.4101 4.34031 12.5466 3.94023C11.6831 3.54014 10.7428 3.33303 9.7911 3.3333C8.56897 3.3331 7.3703 3.66885 6.32609 4.30386C5.28188 4.93887 4.43231 5.8487 3.87024 6.93392C3.30818 8.01913 3.05523 9.23797 3.13906 10.4572C3.22289 11.6765 3.64026 12.8492 4.34555 13.8473C5.05085 14.8454 6.01694 15.6304 7.13823 16.1165C8.25952 16.6027 9.49287 16.7712 10.7034 16.6038C11.9141 16.4363 13.0553 15.9393 14.0026 15.167C14.9498 14.3948 15.6665 13.377 16.0744 12.225C16.1473 12.0161 16.3003 11.8448 16.4995 11.7487C16.6988 11.6525 16.928 11.6395 17.1369 11.7125C17.3458 11.7854 17.5171 11.9383 17.6132 12.1376C17.7093 12.3368 17.7223 12.5661 17.6494 12.775C17.1405 14.216 16.2452 15.4893 15.0613 16.4556C13.8774 17.422 12.4506 18.0442 10.9368 18.2542C9.42315 18.4642 7.88082 18.254 6.47858 17.6464C5.07633 17.0388 3.86816 16.0573 2.9862 14.8093C2.10424 13.5612 1.58245 12.0947 1.4779 10.57C1.37336 9.04541 1.69008 7.52137 2.39342 6.16463C3.09677 4.80788 4.15966 3.67067 5.46585 2.87737C6.77204 2.08406 8.27122 1.66521 9.79944 1.66663Z",
  fill: "var(--gray-50)"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("mask", {
  id: "mask0_804_78",
  style: {"mask-type":"luminance"},
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "1",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.79939 1.66667C10.9853 1.66638 12.1571 1.92412 13.2335 2.42201C14.3099 2.9199 15.2651 3.64603 16.0327 4.55L17.1661 3.54167C17.2862 3.43627 17.4342 3.36765 17.5923 3.34401C17.7504 3.32037 17.912 3.3427 18.0577 3.40833C18.2039 3.47406 18.3281 3.58056 18.4153 3.71507C18.5025 3.84957 18.5491 4.00637 18.5494 4.16667V7.5C18.5494 7.72102 18.4616 7.93298 18.3053 8.08926C18.149 8.24554 17.9371 8.33333 17.7161 8.33333H13.9661C13.7981 8.33284 13.6344 8.28166 13.4961 8.18649C13.3578 8.09133 13.2515 7.95662 13.1911 7.8C13.1296 7.64129 13.1182 7.46758 13.1585 7.30222C13.1986 7.13685 13.2886 6.98777 13.4161 6.875L14.7911 5.65C14.176 4.9238 13.4101 4.34036 12.5466 3.94027C11.6831 3.54018 10.7427 3.33307 9.79106 3.33333C8.56889 3.33314 7.37023 3.66889 6.32602 4.3039C5.28181 4.93892 4.43224 5.84874 3.87017 6.93396C3.30811 8.01918 3.05517 9.238 3.13899 10.4573C3.22282 11.6765 3.64019 12.8493 4.34549 13.8473C5.05079 14.8454 6.01687 15.6304 7.13817 16.1166C8.25946 16.6027 9.49281 16.7713 10.7034 16.6038C11.9141 16.4363 13.0553 15.9393 14.0026 15.1671C14.9497 14.3948 15.6665 13.3771 16.0744 12.225C16.1473 12.0162 16.3002 11.8448 16.4995 11.7487C16.6987 11.6526 16.928 11.6396 17.1369 11.7125C17.3457 11.7854 17.5171 11.9383 17.6131 12.1376C17.7093 12.3368 17.7223 12.5662 17.6494 12.775C17.1405 14.216 16.2451 15.4893 15.0612 16.4557C13.8774 17.4221 12.4506 18.0443 10.9368 18.2543C9.42306 18.4643 7.88076 18.254 6.47851 17.6464C5.07626 17.0388 3.86809 16.0573 2.98613 14.8093C2.10417 13.5613 1.58238 12.0948 1.47784 10.5701C1.37329 9.04542 1.69001 7.52142 2.39336 6.16467C3.09671 4.80793 4.1596 3.67072 5.46578 2.87741C6.77197 2.0841 8.27115 1.66525 9.79939 1.66667Z",
    fill: "white"
  })
], -1))
const _hoisted_4 = { mask: "url(#mask0_804_78)" }
const _hoisted_5 = {
  cx: "10.0001",
  cy: "10",
  r: "5",
  transform: "rotate(12.7445 10.0001 10)",
  stroke: "var(--gray)",
  "stroke-width": "16",
  "stroke-dasharray": "30",
  "stroke-dashoffset": "30"
}
const _hoisted_6 = ["dur"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("animateTransform", {
  id: "transform_1",
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  from: "-15 0 0",
  to: "390 0 0",
  dur: "0.3",
  begin: "updateTimerIcon.click;",
  repeatCount: "1"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("animateTransform", {
  id: "transform_2",
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  from: "390 0 0",
  to: "360 0 0",
  dur: "0.12",
  begin: "transform_1.end",
  repeatCount: "1"
}, null, -1))

import { computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateTimerIcon',
  props: {
    interval: null,
    disabled: { type: Boolean }
  },
  emits: ["click", "timerUpdate"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click'): void;
  (e: 'timerUpdate'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  interval?: number | string;
  disabled?: boolean;
}





const updateIntervalDefault = '10';
const updateInterval = computed(() => `${props.interval ?? updateIntervalDefault}s`);

onMounted(() => {
  const animationElement = document.getElementById('fillAnimate') as unknown as SVGAnimationElement;
  animationElement.addEventListener('repeatEvent', () => emits('timerUpdate'));
  animationElement.beginElement();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    class: "button-plain",
    disabled: __props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (!__props.disabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("g", _hoisted_4, [
                _createElementVNode("circle", _hoisted_5, [
                  _createElementVNode("animate", {
                    id: "fillAnimate",
                    attributeName: "stroke-dashoffset",
                    values: "30;1",
                    begin: "updateTimerIcon.click, 0s",
                    repeatCount: "indefinite",
                    dur: _unref(updateInterval)
                  }, null, 8, _hoisted_6)
                ])
              ]),
              _hoisted_7,
              _hoisted_8
            ], 64))
          : _createCommentVNode("", true)
      ]))
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})